export class ChangeMemberStatusApiError extends Error {
    kind;
    currentVersion;
    constructor(kind, message, currentVersion) {
        super(message);
        this.kind = kind;
        this.currentVersion = currentVersion;
        this.name = 'ChangeMemberStatusApiError';
    }
}
export async function changeMemberStatus(baseUrl, memberId, input) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/status`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(input),
        });
    }
    catch {
        throw new ChangeMemberStatusApiError('unavailable', 'No pudimos cambiar el estado.');
    }
    const payload = (await response.json().catch(() => ({})));
    const message = payload.message ?? 'No pudimos cambiar el estado.';
    if (response.status === 400)
        throw new ChangeMemberStatusApiError('validation', message);
    if (response.status === 401)
        throw new ChangeMemberStatusApiError('unauthorized', message);
    if (response.status === 403)
        throw new ChangeMemberStatusApiError('forbidden', message);
    if (response.status === 404)
        throw new ChangeMemberStatusApiError('not-found', message);
    if (response.status === 409 && payload.code === 'MEMBER_VERSION_CONFLICT')
        throw new ChangeMemberStatusApiError('version-conflict', message, payload.currentVersion);
    if (response.status === 409 && payload.code === 'MEMBER_STATUS_TRANSITION_CONFLICT')
        throw new ChangeMemberStatusApiError('transition-conflict', message);
    if (!response.ok)
        throw new ChangeMemberStatusApiError('unavailable', message);
    return payload;
}
